<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title font">Condiciones de la categoría</h3>
    <button type="button" (click)="closeDialog()" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- El check y los botones quedan al final del scroll del modal: hay que llegar abajo para verlos -->
  <div class="modal-body" (scroll)="onScroll($event)" style="max-height:calc(100vh - 160px);min-height:0;overflow-y:auto;">
    <iframe *ngIf="fileUrl" [src]="fileUrl" style="width:100%;height:calc(100vh - 160px);min-height:400px;border:1px solid #ccc;display:block;"></iframe>

    <div style="display:flex;align-items:center;gap:8px;margin-top:1em;">
      <input type="checkbox" id="documentoLeido" style="margin:0;" [(ngModel)]="documentoLeido" [disabled]="!scrolledToEnd" />
      <label for="documentoLeido" style="margin:0;" [style.cursor]="scrolledToEnd ? 'pointer' : 'not-allowed'">He leído el documento completo</label>
    </div>

    <div class="modal-footer actions" style="padding:1em 0 0;">
      <div class="note"></div>
      <div class="button-group">
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary">Cancelar</button>
        <button type="button" (click)="aceptar()" class="btn btn-primary" [disabled]="!documentoLeido">Aceptar</button>
      </div>
    </div>
  </div>
</div>
